const getAccessCodesWithoutRemoveMiddleSpace = (text: string) => {
    let result: string[] = [];
    // 根据换行符进行切割
    const strArray = text.split(/[(\r\n)\r\n]+/);
    strArray.forEach((item) => {
        if (item !== '') {
            result = result.concat(item.trim().split(','));
        }
    });
    return result.filter((item) => item !== '').toString();
};
export {
    getAccessCodesWithoutRemoveMiddleSpace
}